import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
  selector: 'ngx-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent implements OnInit {
  @Output() public switchToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  private isOn = false;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  public ngOnInit() {
  }

  public toggleSwitch(event) {
    if (event) {
      event.preventDefault();
    }

    this.isOn = !this.isOn;
    this.switchToggled.emit(this.isOn);
  }

  // HostListener is triggered after internal events.
  @HostListener('click') onClick() {
    const toggleSwitchElement = this.elementRef.nativeElement.querySelector('.toggle-switch');
    if (this.isOn) {
      this.renderer.addClass(toggleSwitchElement, 'is-on');
      return;
    }

    this.renderer.removeClass(toggleSwitchElement, 'is-on');
  }
}
